"use client";
import React, { useEffect } from "react";

import SimilarJobs from "./components/SimilarJobs/SimilarJobs.pc";
import MainSection from "./components/MainSection/MainSection.pc";
import ReportJob from "./components/ReportJob/ReportJob.pc";
import Company from "./components/Company/Company.pc";
import Reminder from "./components/Reminder/Reminder.pc";
// import AdSlot from "app/components/AdSlot";
import { useJobTrans } from "./jobTransProvider";
import Search from "./components/Search/Search.pc";
import SignUp from "./components/SignUp/SignUp.pc";
import styles from "./page.pc.module.scss";
import { trackAdjustEventBySite } from "app/components/adjust";
import Link from "next/link";
import Image from "next/image";

export const JobTransWrapped = ({
  lang,
  pageData,
  jobId,
  sessionid,
  isMobile,
  dictionary,
  countryKey
}) => {
  const { transData } = useJobTrans();
  const banner_job_detail = pageData?.banner_job_detail_page_map?.job_detail_page ?? {};
  useEffect(() => {
    const eventTokens = {
      sg: "1h9o3b",
      jp: "n4lq1o",
      ph: "du1p9i",
      com: "eh43gt",
      id: "5v0kkj"
    };
    trackAdjustEventBySite(eventTokens);
  }, []);
  return (
    <>
      <div className={styles.main}>
        <MainSection
          dictionary={dictionary}
          countryKey={countryKey}
          transData={transData}
          sessionid={sessionid}
          jobId={jobId}
          data={pageData}
        />
        <div className={styles.rbox}>
          <SimilarJobs lang={lang} data={pageData.similar_job} />
          <Search jobId={jobId} data={pageData.search_info} />
        </div>
      </div>
      <div className={styles.aside}>
        <div className={styles.rbox}>
          <Company
            data={{
              ...pageData.company,
              ...pageData.brand_and_product
            }}
            jobId={jobId}
            lang={lang}
            isMobile={isMobile}
            isRemote={pageData?.job_header?.is_remote_job}
          />
          <SignUp sessionid={sessionid} data={dictionary?.jobDetail?.aside?.signUp ?? {}} />
          <ReportJob
            jobId={jobId}
            sessionid={sessionid}
            data={dictionary?.jobDetail?.content ?? {}}
          />
        </div>
        <div className={styles.rbox}>
          <Reminder
            dictionary={dictionary?.jobDetail?.reminder}
            sessionid={sessionid}
            jobId={jobId}
          />
          <div className={styles.adContent}>
            {banner_job_detail?.url ? (
              <Link href={banner_job_detail?.url}>
                <img src={banner_job_detail?.picture_url} alt='' height={180} />
              </Link>
            ) : (
              banner_job_detail?.picture_url && (
                <img src={banner_job_detail?.picture_url} alt='' height={180} />
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default JobTransWrapped;
